// LeadsDensityMap.js
import React from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.heat';

class LeadsDensityMap extends React.Component {
  map = null;
  mapContainer = React.createRef();

  componentDidMount() {
    this.map = L.map(this.mapContainer.current).setView([22.9734, 78.6569], 5);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map);

    // Heat layer (optional)
    const heatPoints = this.props.leads.map(({ lat, lng, count }) => [lat, lng, count]);
    
    L.heatLayer(heatPoints, { radius: 20, blur: 20, maxZoom: 15, minOpacity: 0.2 }).addTo(this.map);

    // Compute max/min for scaling
    const counts = this.props.leads.map(l => l.count);
    const maxCount = Math.max(...counts);
    const minCount = Math.min(...counts);

    // Helper to normalize [minCount..maxCount] → [0..1]
    const norm = count => (count - minCount) / (maxCount - minCount || 1);

    // Add circle markers sized & colored by count
    this.props.leads.forEach(({ lat, lng, count, city }) => {
      const factor = norm(count);
      const radius = 5 + factor * 20;  // between 5px and 25px
      // color from green (low) → red (high)
      const fillColor = `hsl(${(1 - factor) * 120}, 100%, 50%)`;

      const circle = L.circleMarker([lat, lng], {
        radius,
        fillColor,
        color: '#000',
        weight: 0.5,
        fillOpacity: 0.15
      }).addTo(this.map);

      circle.bindTooltip(
        `<strong>${count}<strong>`,
        { permanent: false, direction: 'auto', opacity: 0.7,  }
      );
    });
  }

  componentWillUnmount() {
    if (this.map) this.map.remove();
  }

  render() {
    return (
      <div
        ref={this.mapContainer}
        style={{ width: '100%', height: '100vh' }}
      />
    );
  }
}

export default LeadsDensityMap;
